<template>
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.1641 3.83333L11.9891 5.00833L14.1391 7.16667H5.66406V8.83333H14.1391L11.9891 10.9833L13.1641 12.1667L17.3307 8M2.33073 2.16667H8.9974V0.5H2.33073C1.41406 0.5 0.664062 1.25 0.664062 2.16667V13.8333C0.664062 14.75 1.41406 15.5 2.33073 15.5H8.9974V13.8333H2.33073V2.16667Z" fill="currentColor"/>
  </svg>
</template>
